export const discountPromJsonSchema = {
  type: 'object',
  properties: {
    contractDiscount: {
      type: 'string',
      description: 'OD',
    },
    promotionalDiscount: {
      type: 'string',
    },
    estimatedPromotionalPoints: {
      type: 'string',
    },
    promotionalPoints: {
      type: 'string',
    },
  },
}

export const discountPromUiSchema = {
  type: 'VerticalLayout',
  className: 'identification-filters',
  elements: [
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/contractDiscount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Contract Discount',
        },
        {
          type: 'Control',
          scope: '#/properties/promotionalDiscount',
          component: 'ReadOnlyFieldWithJson',
          label: 'Promotional Discount',
        },
        {
          type: 'Control',
          scope: '#/properties/estimatedPromotionalPoints',
          component: 'ReadOnlyFieldWithJson',
          label: 'Estimated Promotional Points',
        },
      ],
    },
    {
      type: 'HorizontalLayout',
      elements: [
        {
          type: 'Control',
          scope: '#/properties/promotionalPoints',
          component: 'ReadOnlyFieldWithJson',
          label: 'Promotional Points',
        },
      ],
    },
  ],
}
